import { styled } from '@mui/system'

export const RolesTitleWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const RulesWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 14px;
`
